const KEY = 'user'
// const Last = 'last_student_sn'
export default {
  // user 是调用setUser传入的用户信息对象
  setUser (user, last) {
    window.sessionStorage.setItem(KEY, JSON.stringify(user))
    // window.sessionStorage.setItem(Last, last)
  },
  setAreaCode (areacode) {
    window.sessionStorage.setItem('areaCode', JSON.stringify(areacode))
  },
  getAreaCode () {
    return JSON.parse(window.sessionStorage.getItem('areaCode') || '{}')
  },
  // 得到用户信息对象
  getUser () {
    return JSON.parse(window.sessionStorage.getItem(KEY) || '{}')
  },
  delUser () {
    window.sessionStorage.removeItem(KEY)
  },
  setMsgNum(msgnum) {
    window.sessionStorage.setItem('msgnum', JSON.stringify(msgnum))
  },
  getMsgNum () {
    return JSON.parse(window.sessionStorage.getItem('msgnum') || '{}')
  },
}



// WEBPACK FOOTER //
// ./src/store/store.js